import {Routes, Route} from "react-router-dom"

// Nível raiz (/)
import HomeScreen from "pages/Home"

// Nível 1 (/AlgumaCoisa)
import { NotFoundScreen } from "pages/NotFound"
import { EntrarScreen } from "pages/Entrar"
import { SemPermissaoScreen } from "pages/SemPermissao"
import { TestesScreen } from "pages/RealizarTestes"

// Fluxo da Minha conta
import { MinhaContaScreen } from "pages/MinhaConta/index"
import { AlterarMinhaSenhaScreen } from "pages/MinhaConta/AlterarSenha"
import { MeusProcessosScreen } from "pages/MinhaConta/MeusProcessos/index"
import { VerProcessoScreen } from "pages/MinhaConta/MeusProcessos/VerProcesso/index"
import { VerDocumentoScreen } from "pages/MinhaConta/MeusProcessos/VerProcesso/VerDocumento"
import { MeusDocumentosScreen } from "pages/MinhaConta/_MeusDocumentos"

// Fluxo de Gestão
import { CadastrarUsuarioScreen } from "pages/Gestao/CadastrarUsuario"
import { GerenciarPermissoesScreen } from "pages/Gestao/GerenciarPermissoesUsuario"
import { AlterarSenhaUsuarioScreen } from "pages/Gestao/AlterarSenhaUsuario"
import { LevantamentosScreen } from "pages/Gestao/Levantamentos"
import { VerFuncionariosScreen } from "pages/Gestao/VerFuncionarios"

// Fluxo de Calculadora de Taxas (legado)
import { TaxasLegadoServicosScreen } from "pages/TaxasLegado/index"
import { CalcularTaxaLegadoScreen } from "pages/TaxasLegado/CalcularTaxaServico/index"

// Fluxo de Calculadora de Taxas (CTM24)
import { TaxasServicosCTM24Screen } from "pages/TaxasCTM24/index"
import { CalcularTaxaCTM24Screen } from "pages/TaxasCTM24/CalcularTaxaServico/index"
import { GerarDocumentoScreen } from "pages/TaxasCTM24/CalcularTaxaServico/GerarDocumento"
import { GerarGuiaDePagamentoScreen } from "pages/TaxasCTM24/CalcularTaxaServico/GerarGuiaDePagamento"
import { GerarMultaScreen } from "pages/TaxasCTM24/CalcularTaxaServico/GerarMulta"
import { DocGeradoComSucessoScreen } from "pages/TaxasCTM24/CalcularTaxaServico/DocGeradoComSucesso"

// Fluxo de iniciar processo
import { IniciarOuContinuarProcessoScreen } from "pages/IniciarProcesso/index"
import { ProcessoServicosScreen } from "pages/IniciarProcesso/Servicos"

// Fluxo de Gerar Documento
import { EscolhaProcessoScreen } from "pages/EscolhaGuia/index"
//import { ProcessoServicosScreen } from "pages/IniciarProcesso/Servicos"

import * as Links from "constants/links"
import { MinhasMultasScreen } from "pages/MinhaConta/MinhasMultas"

export default function LUARoutes()
{
    return (
        <Routes>
            {/* Nível raiz (/)*/}
            <Route path={Links.HOME} element={<HomeScreen/>}/>

            {/* Nível 1 (/AlgumaCoisa) */}
            <Route path={Links.ENTRAR}  element={<EntrarScreen/>}/>
            <Route path={Links.TESTES}  element={<TestesScreen/>}/>
            <Route path={Links.SEM_PERMISSAO} element={<SemPermissaoScreen />} />
            <Route path="*" element={<NotFoundScreen />} />

            {/* Fluxo de Minha conta */}
            <Route path={Links.MINHA_CONTA}>
                <Route index element={<MinhaContaScreen/>}/>
                <Route path={Links.ALTERAR_SENHA} element={<AlterarMinhaSenhaScreen/>}/>
                <Route path={Links.MEUS_PROCESSOS}>
                    <Route index element={<MeusProcessosScreen/>}/>
                    <Route path={Links.VER_PROCESSO}>
                        <Route index element={<VerProcessoScreen/>}/>
                        <Route path={Links.VER_DOCUMENTO} element={<VerDocumentoScreen/>}/>
                    </Route>
                </Route>
                <Route path={Links.MEUS_DOCUMENTOS}  element={<MeusDocumentosScreen/>}/>
                <Route path={Links.MINHAS_MULTAS} element={<MinhasMultasScreen />} />
            </Route>
            
            {/* Fluxo de Gestão */}
            <Route path={Links.GESTAO}>
                <Route path={Links.CADASTRAR_USUARIO} element={<CadastrarUsuarioScreen />}/>
                <Route path={Links.GERENCIAR_PERMISSOES} element={<GerenciarPermissoesScreen/>}/>
                <Route path={Links.LEVANTAMENTOS} element={<LevantamentosScreen/>}/>
                <Route path={Links.ALTERAR_SENHA_USUARIO} element={<AlterarSenhaUsuarioScreen/>}/>
                <Route path={Links.VER_FUNCIONARIOS} element={<VerFuncionariosScreen/>}/>
            </Route>

            {/* Fluxo de Calculadora de Taxas (legado) */}
            <Route path={Links.SERVICOS_TAXAS_LEGADO}>
                <Route index element={<TaxasLegadoServicosScreen/>}/>
                <Route path={Links.CALCULAR_TAXAS_LEGADO}>
                    <Route index element={<CalcularTaxaLegadoScreen/>}/>
                </Route>
            </Route>

            {/* Fluxo de Calculadora de Taxas (CTM24) */}
            <Route path={Links.SERVICOS_TAXAS_CTM24}>
                <Route index element={<TaxasServicosCTM24Screen/>}/>
                <Route path={Links.CALCULAR_TAXAS_CTM24}>
                    <Route index element={<CalcularTaxaCTM24Screen/>}/>
                    <Route path={Links.GERAR_GUIA_DE_PAGAMENTO} element={<GerarGuiaDePagamentoScreen />} />
                    <Route path={Links.GERAR_MULTA} element={<GerarMultaScreen />} />
                    <Route path={Links.GERAR_DOCUMENTO} element={<GerarDocumentoScreen />} />
                    <Route path={Links.DOC_GERADO_COM_SUCESSO} element={<DocGeradoComSucessoScreen/>}/>
                </Route>
            </Route>

            <Route path={Links.INICIAR_OU_CONTINUAR_PROCESSO}>
                <Route index element={<IniciarOuContinuarProcessoScreen/>}/>
                <Route path={Links.PROCESSO_SERVICOS} element={<ProcessoServicosScreen />} />
            </Route>

            <Route path={Links.ESCOLHA_SUA_GUIA}>
                <Route index element={<EscolhaProcessoScreen/>}/>
            </Route>

        </Routes>
    )
}